import type { RecentBuilding } from '@quipex/feature/building-context';
import type { BuildingCandidate } from './models';

const MAX_DEFAULT_BUILDING_CANDIDATES = 5;

export function mergeDefaultBuildingCandidates(
    recentBuildings: readonly RecentBuilding[],
    portfolioBuildings: readonly BuildingCandidate[],
    excludedIds: ReadonlySet<string> = new Set()
): readonly BuildingCandidate[] {
    const portfolioById = new Map(
        portfolioBuildings.map((building) => [building.id, building])
    );
    const combined = [
        ...recentBuildings.map((building) => {
            const portfolio = portfolioById.get(building.id);
            if (!portfolio) return building;

            return {
                ...portfolio,
                primaryPropertyType: building.primaryPropertyType,
                ...(building.subPremiseType !== undefined
                    ? { subPremiseType: building.subPremiseType }
                    : {}),
            };
        }),
        ...portfolioBuildings,
    ];
    const seen = new Set<string>();

    return combined
        .filter((building) => {
            if (excludedIds.has(building.id) || seen.has(building.id)) {
                return false;
            }

            seen.add(building.id);
            return true;
        })
        .slice(0, MAX_DEFAULT_BUILDING_CANDIDATES)
        .map(toBuildingCandidate);
}

function toBuildingCandidate(
    building: RecentBuilding | BuildingCandidate
): BuildingCandidate {
    return {
        id: building.id,
        name: building.name,
        address: building.address,
        primaryPropertyType: building.primaryPropertyType,
        ...('subPremiseType' in building &&
        building.subPremiseType !== undefined
            ? { subPremiseType: building.subPremiseType }
            : {}),
        ...('ownerOrgName' in building && building.ownerOrgName
            ? { ownerOrgName: building.ownerOrgName }
            : {}),
    };
}
